<template>
    <div class="mt-5 mb-5">
        <data-table ref="events"
                    :api-route="backendApiRoute"
                    :api-view-set="table.apiViewSet"
                    :name="table.name"
                    :columns="table.columns"
                    :search="table.search"
                    :filters="table.filters ? table.filters : []"
                    :initial-filters="initialFilters"
                    :actions="table.actions"
                    :orderings="table.orderings"
                    :initial-orderings="table.initialOrderings"
                    :row-actions="table.rowActions"
                    :key="table.key"
                    :destroy-title="'Удаление мероприятия'"
                    :context-menu-wrapper-id="''"
                    @object-delete-success="onKeepingEventDeleted">
        </data-table>
    </div>
</template>

<script>
    import DataTable from "../../../../components/Table/DataTable";
    import {mapGetters} from "vuex";
    import api from "../../../../api";
    import {BaseEvent, eventFactory, EventKind} from "../event";
    import actions, {AvailableAction} from "../../../../components/Table/actions";
    import store from "@/store";

    export default {
        name: "KeepingEventList",
        components: { DataTable },
        props: {
            animal: { type: Object, default: () => { return {} } },
        },
        data() {
            const name = 'keeping-events-table';
            let columns = [];

            columns.push({ name: 'id', 'title': 'Номер',
                to: {
                    idColumn: 'id',
                    routeName: 'eventDetail',
                    prependWithN: true
                },
                alwaysVisible: true
            });

            columns.push(
                { name: 'executor_contractor_name', 'title': 'Организация'},
                { name: 'attributes.forLife', 'title': 'Пожизненно', cellComponentName: 'BooleanCell',
                    cellComponentPath: 'src/pages/DataTableCells/'},
                { name: 'executor_name', 'title': 'Провел'},
                { name: 'execution_date', 'title': 'Проведено',
                        cellComponentName: 'DateTimeCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
                { name: 'created_at', 'title': 'Создано',
                        cellComponentName: 'DateTimeCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
            );

            return {
                table: {
                    name: name,
                    apiViewSet: api.events.default,
                    key: name,
                    search: true,
                    columns: columns,
                    orderings: [
                        'id',
                        { 'created_at_date_only': 'created_at' },
                        { 'execution_date_only': 'execution_date' },
                    ],
                    actions: [],
                    rowActions: [],
                    filters: [],
                    initialFilters: {},
                    initialOrderings: { id: 2 }
                }
            }
        },
        computed: {
            ...mapGetters(['ability', 'userOrganizationId']),
            backendApiRoute() {
                return api.events.default.list()
            },
            initialFilters() {
                return { 'kind': EventKind.KEEPING, 'animal': this.animal.id };
            }
        },
        methods: {
            onKeepingEventDeleted() {
                this.$emit('on-event-deleted')
            }
        },
        mounted() {
            const vm = this;
            const canCreate = this.ability.can('create', 'KeepingEvent');

            // PETS-298: чтобы добавить мероприятие по содержанию, животное должно быть живо и не содержаться в любом приюте
            const isShelterObjectAvailable = this.animal.shelterObject !== null && this.animal.shelterObject !== undefined
            const isKept = this.animal.isKept;
            const isAlive = this.animal.alive;
            const canKeep = this.animal.canKeep;

            console.log(canCreate, isKept, isAlive)

            if ((isShelterObjectAvailable && !isKept && isAlive) || (!isShelterObjectAvailable && canKeep)) {
                const createAction = actions.create(() => {
                        vm.$router.push({
                            name: 'eventCreate',
                            params: {kind: EventKind.KEEPING, animalId: vm.animal.id}
                        })
                    }, canCreate
                )
                this.table.actions.push(createAction);
            }

            if (this.ability.can('destroy', 'KeepingEvent')) {
                const destroyAction = new AvailableAction({ title: 'Удалить', icon: 'trash', emittedEvent: 'on-delete' }, (id, row) => {
                    const objectClass = eventFactory(row['kind']);
                    const object = new objectClass();
                    object.applyData(row);
                    return object
                }, (row) => {
                    const objectClass = new eventFactory(row['kind']);
                    const object = new objectClass();
                    object.applyData(row);
                    return store.getters.ability.can('destroy', object);
                })
                this.table.rowActions.push(destroyAction);
            }
        }
    }
</script>

<style scoped>

</style>